import React from "react";
import PropTypes from "prop-types";
import "../../css/components/reusable/Avatar.css";

const Avatar = ({ image, name, size = "md", alt }) => {
    const avatarUrl =
        image ||
        `https://ui-avatars.com/api/?background=random&name=${encodeURIComponent(name || "User")}`;

    return (
        <img
            src={avatarUrl}
            alt={alt || name}
            className={`avatar avatar-${size}`}
        />
    );
};

Avatar.propTypes = {
    image: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string,
    size: PropTypes.oneOf([ "xs", "sm", "md", "lg", "xl" ]),
};

export default Avatar;
